import React, { useState, useEffect } from 'react';

import axios from 'axios';
import swal from 'sweetalert';

import { Link } from 'react-router-dom';

const AddProduct = () => {

    const [featureImage, setFeatureImage] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    const [formData, setFormData] = useState({
        category_id: '',
        slug: '',
        name: '',
        description: '',

        meta_title: '',
        meta_keyword: '',
        meta_description: '',

        sale_price: '',
        original_price: '',
        qty: 1,
        brand: '',

        featured: false,
        popular: false,
        status: false,
        error_list: [],
    });

    useEffect(() => {
        axios.get(`api/all-categories`)
            .then(res => {
                if (res.data.status === 200) {
                    setCategoryList(res.data.categories);
                }
            });
    }, []);

    const handeInput = (e) => {
        e.persist();
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    }

    const handleImage = (e) => {
        setFeatureImage({ image: e.target.files[0] });
    }

    const handleFormSubmit = (e) => {

        e.preventDefault();

        let formInputs = new FormData();

        formInputs.append("category_id", formData.category_id);
        formInputs.append("slug", formData.slug);
        formInputs.append("name", formData.name);
        formInputs.append("description", formData.description);

        formInputs.append("meta_title", formData.meta_title);
        formInputs.append("meta_keyword", formData.meta_keyword);
        formInputs.append("meta_description", formData.meta_description);

        formInputs.append("sale_price", formData.sale_price);
        formInputs.append("original_price", formData.original_price);
        formInputs.append("qty", formData.qty);
        formInputs.append("brand", formData.brand);

        formInputs.append("featured", formData.featured);
        formInputs.append("popular", formData.popular);
        formInputs.append("status", formData.status);

        formInputs.append("image", featureImage.image);


        axios.post(`api/store-product`, formInputs, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(res => {
                if (res.data.status === 200) {
                    swal("Success", res.data.message, "success");
                    setFormData({
                        ...formData,
                        category_id: '',
                        slug: '',
                        name: '',
                        description: '',
                        meta_title: '',
                        meta_keyword: '',
                        meta_description: '',
                        sale_price: '',
                        original_price: '',
                        qty: '',
                        brand: '',
                        featured: '',
                        popular: '',
                        status: '',
                        error_list: [],
                    });
                    setFeatureImage([]);

                } else if (res.data.status === 400) {
                    swal("Warning!", "Please fill out the required fields correctly", "error")
                    setFormData({ ...formData, error_list: res.data.errors });
                }
            });
    }

    return (
        <form onSubmit={handleFormSubmit} id="PRODUCT-FORM" encType="multipart/form-data" method='post'>
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h3 className="h5 mb-0 text-gray-800">Add Product</h3>
                    <Link to="/admin/view-products" className="btn btn-primary btn-md">View Products</Link>
                </div>
                <div className="card-body">
                    <ul className="nav nav-pills">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="pill" href="#main-details">
                                Main Details
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="pill" href="#seo-details">
                                SEO Details
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="pill" href="#other-details">
                                Other Details
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div className="tab-pane container active" id="main-details">
                            <div className='row'>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Category *</label>
                                    <select className="form-control" name="category_id" onChange={handeInput} value={formData.category_id}>
                                        <option>Select Category</option>
                                        {
                                            categoryList.map((cat) => {
                                                return (
                                                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                                                );
                                            })
                                        }
                                    </select>
                                    <small className='text-danger'>{formData.error_list.category_id}</small>
                                </div>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Slug *</label>
                                    <input type="text" className="form-control" name="slug" onChange={handeInput} value={formData.slug} />
                                    <small className='text-danger'>{formData.error_list.slug}</small>
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Name *</label>
                                    <input type="text" className="form-control" name="name" onChange={handeInput} value={formData.name} />
                                    <small className='text-danger'>{formData.error_list.name}</small>
                                </div>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Brand *</label>
                                    <input type="text" className="form-control" name="brand" onChange={handeInput} value={formData.brand} />
                                    <small className='text-danger'>{formData.error_list.brand}</small>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-lg-12 mb-3 mt-3">
                                    <label className="form-label">Description</label>
                                    <textarea className="form-control" name="description" onChange={handeInput} value={formData.description}></textarea>
                                    <small className='text-danger'>{formData.error_list.description}</small>
                                </div>
                            </div>
                            <div className="col-lg-6 mb-3 mt-3">
                                <label className="form-label pr-2">Status</label>
                                <input type="checkbox" name="status" onChange={handeInput} value={formData.status} checked={formData.status} />
                                <span className='pl-3'> Status 0 = shown, 1 = hidden</span>
                            </div>
                        </div>

                        <div className="tab-pane container fade" id="seo-details">
                            <div className="mb-3 mt-3">
                                <label className="form-label">Title *</label>
                                <input type="text" className="form-control" name="meta_title" onChange={handeInput} value={formData.meta_title} />
                                <small className='text-danger'>{formData.error_list.meta_title}</small>
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Keywords</label>
                                <input type="text" className="form-control" name="meta_keyword" onChange={handeInput} value={formData.meta_keyword} />
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" name="meta_description" onChange={handeInput} value={formData.meta_description}></textarea>
                            </div>
                        </div>

                        <div className="tab-pane container fade" id="other-details">
                            <div className='row'>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Sale Price *</label>
                                    <input type="text" className="form-control" name="sale_price" onChange={handeInput} value={formData.sale_price} />
                                    <small className='text-danger'>{formData.error_list.sale_price}</small>
                                </div>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Original Price *</label>
                                    <input type="text" className="form-control" name="original_price" onChange={handeInput} value={formData.original_price} />
                                    <small className='text-danger'>{formData.error_list.original_price}</small>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Quantity *</label>
                                    <input type="text" className="form-control" name="qty" onChange={handeInput} value={formData.qty} />
                                    <small className='text-danger'>{formData.error_list.qty}</small>
                                </div>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label">Image *</label>
                                    <input type="file" className="form-control" name="image" onChange={handleImage} />
                                    <small className='text-danger'>{formData.error_list.image}</small>
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label pr-2">Featured</label>
                                    <input type="checkbox" name="featured" onChange={handeInput} value={formData.featured} checked={formData.featured} />
                                </div>
                                <div className="col-lg-6 mb-3 mt-3">
                                    <label className="form-label pr-2">Popular</label>
                                    <input type="checkbox" name="popular" onChange={handeInput} value={formData.popular} checked={formData.popular} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <button type="submit" className="btn btn-primary mb-2 mr-3 ml-3">Submit</button>

            </div>
        </form>
    );
}

export default AddProduct;